import React, { useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  Button,
  Paper,
  Stack,
  Dialog,
  DialogContent,
  InputBase,
  IconButton
} from "@mui/material";
import GroupIcon from "@mui/icons-material/Groups";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import CustomDepartmentSelect from "./CustomDepartmentSelect";

const labelStyle = {
  marginBottom: '4px',
  fontWeight: 600,
  color: '#1A1A1A',
  fontSize: '14px',
};

const allProjects = [
  {
    name: "Project Orion",
    description: "Driving product development with precision and purpose.",
    color: "#6A1B9A"
  },
  {
    name: "Nova Initiative",
    description: "Breaking new ground with innovative strategies.",
    color: "#0277BD"
  },
  {
    name: "Echo Framework",
    description: "Streamlining infrastructure with modular systems.",
    color: "#F9A825"
  }
];

const ProjectsRole = () => {
  const [projects, setProjects] = useState([allProjects[0]]);
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const isProjectAdded = (projectName) =>
    projects.some((p) => p.name === projectName);

  const handleToggleProject = (project) => {
    if (isProjectAdded(project.name)) {
      setProjects((prev) => prev.filter((p) => p.name !== project.name));
    } else {
      setProjects((prev) => [...prev, project]);
    }
  };

  const filteredProjects = allProjects.filter(
    (project) =>
      project.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      project.description.toLowerCase().includes(searchQuery.toLowerCase())
  );


  const rolesOptions = [
    'Admin', 'User', 'Manager', 'Organization Owner  ',
  ]

  return (
    <Box>
      <Box mb={2}>
        <Typography variant="body2" sx={labelStyle}>
          Roles
        </Typography>
        <CustomDepartmentSelect selectedPlaceholder="Select Roles" modalSearchplaceHolder="Search Roles" initialOptions={rolesOptions} showAddOption={false} />
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography
          variant="body2"
          sx={{ color: projects.length === 0 ? "#64748B" : "#0076FE" }}
        >
          PROJECTS ({projects.length})
        </Typography>

        <Button
          variant="outlined"
          onClick={() => setOpen(true)}
          sx={{
            borderRadius: "50px",
            fontSize: "14px",
            color: "#0076FE",
            border: "1px solid #0076FE",
            textTransform: "none",
            px: 2,
            "&:hover": {
              backgroundColor: "#0076FE",
              borderColor: "#0076FE",
              color: "#fff"
            }
          }}
        >
          + Add Project
        </Button>
      </Box>

      <Stack spacing={2}>
        {projects.map((project, index) => (
          <Paper
            key={index}
            elevation={0}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 2,
              border: "1px solid #e0e0e0",
              borderRadius: 2
            }}
          >
            <Box display="flex" alignItems="center" gap={2}>
              <Avatar sx={{ bgcolor: project.color }}>
                <GroupIcon />
              </Avatar>
              <Box>
                <Typography sx={{ fontSize: "14px", color: "#373737" }} fontWeight={500}>
                  {project.name}
                </Typography>
                <Typography variant="body2" sx={{ fontSize: "12px", color: "#9095A1" }}>
                  {project.description}
                </Typography>
              </Box>
            </Box>
            <Button
              variant="outlined"
              color="inherit"
              size="small"
              sx={{
                borderRadius: "50px",
                color: "#595959",
                border: "1px solid #595959"
              }}
              onClick={() => handleToggleProject(project)}
            >
              Remove
            </Button>
          </Paper>
        ))}
      </Stack>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            border: "4px solid #00AAE7"
          }
        }}
      >
        <Box sx={{ position: "relative", borderBottom: "1px solid #DFDFDF", pb: 2 }}>
          <Typography
            sx={{ px: 3, pt: 2, fontSize: "22px", color: "#1A1F36", fontWeight: "bold" }}
          >
            Add Project
          </Typography>
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="body2" color="text.secondary" px={3} mt={0.5}>
            This field  will be added to all member profiles and can be viewed in reports.
          </Typography>
        </Box>

        <Box px={3} py={1} display="flex" alignItems="center" gap={2}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#fff",
              px: 1.5,
              py: 0.5,
              borderRadius: 20,
              flex: 1
            }}
          >
            <SearchIcon color="action" sx={{ mr: 1 }} />
            <InputBase
              placeholder="Search projects..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              fullWidth
              sx={{ fontSize: 14 }}
            />
          </Box>
          <Typography
            variant="body2"
            whiteSpace="nowrap"
            sx={{ color: projects.length === 0 ? "#64748B" : "#0076FE" }}
          >
            {projects.length} {projects.length === 1 ? "Project" : "Projects"} added
          </Typography>
        </Box>

        <DialogContent
          dividers
          sx={{ maxHeight: "550px", overflowY: "auto" }}
        >
          <Stack spacing={2}>
            {filteredProjects.length === 0 ? (
              <Typography variant="body2" color="text.secondary">
                No projects found.
              </Typography>
            ) : (
              filteredProjects.map((project, index) => {
                const added = isProjectAdded(project.name);
                return (
                  <Paper
                    key={index}
                    elevation={0}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      p: 2,
                      border: "1px solid #e0e0e0",
                      borderRadius: 2
                    }}
                  >
                    <Box display="flex" alignItems="center" gap={2}>
                      <Avatar sx={{ bgcolor: project.color }}>
                        <GroupIcon />
                      </Avatar>
                      <Box>
                        <Typography
                          sx={{ fontSize: "14px", color: "#373737" }}
                          fontWeight={500}
                        >
                          {project.name}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: "12px", color: "#9095A1" }}
                        >
                          {project.description}
                        </Typography>
                      </Box>
                    </Box>
                    <Button
                      size="small"
                      onClick={() => handleToggleProject(project)}
                      sx={{
                        width: "80px",
                        borderRadius: "50px",
                        color: added ? "#595959" : "#0076FE",
                        border: `1px solid ${added ? "#595959" : "#0076FE"}`,
                        textTransform: "none",
                        px: 2
                      }}
                    >
                      {added ? "Remove" : "Add"}
                    </Button>
                  </Paper>
                );
              })
            )}
          </Stack>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ProjectsRole;